/*
 * Instagram の最新投稿を取り込む
 * sections/iroiro-social.liquid
 *
 * 取得先は中継役の Cloudflare Worker（別リポジトリ）。
 * テーマは Worker のレスポンス形だけを知っていればよい。
 *
 *   { ok, posts: [{ permalink, image, caption, timestamp, ... }], profile, pinned }
 *
 * 【気をつける点】
 * ・Worker は失敗しても HTTP 200 で ok:false を返す。
 *   res.ok（ステータス）だけ見ていると失敗に気付けない
 * ・画像URLは署名付きで失効する。保存や再ホストはしない（表示のみ）
 * ・media_type による分岐は不要。動画のサムネイルも Worker が image に入れてくれる
 */
(function () {
  'use strict';

  function init(root) {
    (root || document).querySelectorAll('[data-iroiro-social]').forEach(function (grid) {
      if (grid.dataset.iroiroSocialReady === 'true') return;
      grid.dataset.iroiroSocialReady = 'true';

      var section = grid.closest('.iroiro-social');
      var fallback = section && section.querySelector('[data-iroiro-social-fallback]');
      var iconTemplate = section && section.querySelector('[data-iroiro-social-icon]');
      var feed = grid.dataset.feed;
      var limit = parseInt(grid.dataset.limit, 10) || 8;

      /*
       * 取得先が未設定なら、枠だけが並ぶことになるのでセクションごと隠す。
       * 「設定し忘れ」と「取得に失敗」を見た目で区別できるようにしている。
       */
      if (!feed) {
        if (section) section.hidden = true;
        return;
      }

      function giveUp() {
        grid.hidden = true;
        if (fallback) fallback.hidden = false;
      }

      function render(posts) {
        var alt = grid.dataset.alt || '';
        grid.textContent = '';

        posts.slice(0, limit).forEach(function (post) {
          if (!post.image || !post.permalink) return;

          var link = document.createElement('a');
          link.className = 'iroiro-social__cell';
          // 常に元の投稿へ返す（Instagram の利用条件で求められている）
          link.href = post.permalink;
          link.target = '_blank';
          link.rel = 'noopener';

          var image = document.createElement('img');
          image.src = post.image;
          image.loading = 'lazy';
          image.decoding = 'async';
          /*
           * 代替テキストはキャプションの1行目を使う。
           * キャプションは長く絵文字も多いため、そのまま読み上げさせない。
           * 取れないときは共通の文言にする。
           */
          image.alt = firstLine(post.caption) || alt;

          link.appendChild(image);

          /*
           * 角に Instagram のアイコンを重ねる。
           * 写真だけだと投稿だと伝わらず、外部へ出るリンクだとも分からないため。
           * 読み上げには不要（リンクの説明は alt が担う）ので aria-hidden。
           */
          if (iconTemplate) {
            link.appendChild(iconTemplate.content.cloneNode(true));
          }

          grid.appendChild(link);
        });

        if (!grid.children.length) giveUp();
      }

      function firstLine(caption) {
        if (!caption) return '';
        var line = String(caption).split('\n')[0].trim();
        return line.length > 60 ? line.slice(0, 60) + '…' : line;
      }

      var url = feed + (feed.indexOf('?') === -1 ? '?' : '&') + 'limit=' + limit;

      fetch(url, { mode: 'cors' })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          // ステータスではなく ok を見る。失敗も 200 で返ってくるため
          if (!data || data.ok !== true || !data.posts || !data.posts.length) {
            giveUp();
            return;
          }
          render(data.posts);
        })
        .catch(giveUp);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // テーマエディタでセクションを編集し直したときに繋ぎ直す
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
